import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// project imports
import MainLayout from './../layout/MainLayout';
import Loadable from '../ui-component/Loadable';
import AuthGuard from './../utils/route-guard/AuthGuard';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('../views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('../views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('../views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('../views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('../views/utilities/TablerIcons')));
const ProfilePage = Loadable(lazy(() => import('../views/profile')));
// User Routes
const UserListPage = Loadable(lazy(() => import('../views/user')));
const UserCreatePage = Loadable(lazy(() => import('../views/user/create')));

// Admin Routes
const AdminListPage = Loadable(lazy(() => import('../views/admin')));
const AdminCreatePage = Loadable(lazy(() => import('../views/admin/create')));

// Notification Routes
const NotificationPage = Loadable(lazy(() => import('../views/notification')));

// Category Routes
const CategoryListPage = Loadable(lazy(() => import('../views/category')));
const CategoryCreatePage = Loadable(lazy(() => import('../views/category/create')));

// Project Routes
const ProjectListPage = Loadable(lazy(() => import('../views/projects')));
const ProjectCreatePage = Loadable(lazy(() => import('../views/projects/create')));
const ProjectViewPage = Loadable(lazy(() => import('../views/projects/view')));
const RecycleBinPage = Loadable(lazy(() => import('../views/projects/recycle-bin')));

// Survey Structure Routes
const SurveyStructurePage = Loadable(lazy(() => import('../views/survey-structure')));

// App Version Routes
const AppVersionPage = Loadable(lazy(() => import('../views/app-version')));

// Calendar Route
const CalendarPage = Loadable(lazy(() => import('../views/calendar')));

// Activity Log Route
const ActivityLogPage = Loadable(lazy(() => import('../views/activity-log')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('../views/sample-page')));

//-----------------------|| MAIN ROUTING ||-----------------------//

const MainRoutes = () => {
    const location = useLocation();

    return (
        <Route
            path={[
                '/dashboard/default',
                '/utils/util-typography',
                '/utils/util-color',
                '/utils/util-shadow',
                '/icons/tabler-icons',
                '/icons/material-icons',
                '/sample-page',
                '/profile',
                '/user-list',
                '/user-create',
                '/user-edit/:id',

                '/admin-list',
                '/admin-create',
                '/admin-edit/:id',

                '/notification',

                '/category-list',
                '/category-create',
                '/category-edit/:id',

                '/project-list',
                '/project-create',
                '/project-edit/:id',
                '/project-view/:id',
                '/survey-structure/:projectId',
                '/recycle-bin',
                '/calendar',
                '/activity-log',
                '/app-version',
            ]}
        >
            <MainLayout>
                <Switch location={location} key={location.pathname}>
                    <AuthGuard>
                        <Route path="/dashboard/default" component={DashboardDefault} />

                        <Route path="/utils/util-typography" component={UtilsTypography} />
                        <Route path="/utils/util-color" component={UtilsColor} />
                        <Route path="/utils/util-shadow" component={UtilsShadow} />
                        <Route path="/icons/tabler-icons" component={UtilsTablerIcons} />
                        <Route path="/icons/material-icons" component={UtilsMaterialIcons} />

                        <Route path="/sample-page" component={SamplePage} />
                        <Route path="/profile" component={ProfilePage} />
                        <Route path="/user-list" component={UserListPage} />
                        <Route path="/user-create" component={UserCreatePage} />
                        <Route path="/user-edit/:id" component={UserCreatePage} />
                        <Route path="/admin-list" component={AdminListPage} />
                        <Route path="/admin-create" component={AdminCreatePage} />
                        <Route path="/admin-edit/:id" component={AdminCreatePage} />
                        <Route path="/notification" component={NotificationPage} />
<Route path="/category-list" component={CategoryListPage} />
<Route path="/category-create" component={CategoryCreatePage} />
<Route path="/category-edit/:id" component={CategoryCreatePage} />

<Route path="/project-list" component={ProjectListPage} />
<Route path="/project-create" component={ProjectCreatePage} />
<Route path="/project-edit/:id" component={ProjectCreatePage} />
<Route path="/project-view/:id" component={ProjectViewPage} />
<Route path="/survey-structure/:projectId" component={SurveyStructurePage} />
<Route path="/recycle-bin" component={RecycleBinPage} />
<Route path="/calendar" component={CalendarPage} />
<Route path="/activity-log" component={ActivityLogPage} />
<Route path="/app-version" component={AppVersionPage} />


                                             

                    </AuthGuard>
                </Switch>
            </MainLayout>
        </Route>
    );
};

export default MainRoutes;
